import JOB_TITLE_SYNONYM_GROUPS from './jobTitleSynonyms';

// Pre-built map from lower-cased title → its synonym group for O(1) lookup.
// Titles that appear in more than one group are excluded to avoid ambiguous mappings.
// In the current mapping CCO will be removed since it appears in both "Chief Customer Officer" and "Chief Compliance Officer" groups, but this can be revisited if we want to support some level of ambiguity resolution in the future (e.g. by looking at other titles in the search query).
const allEntries = JOB_TITLE_SYNONYM_GROUPS.flatMap((group) =>
    group.map((title) => [title.toLowerCase(), group] as [string, string[]]),
);
const titleCounts = allEntries.reduce<Map<string, number>>(
    (acc, [title]) => acc.set(title, (acc.get(title) ?? 0) + 1),
    new Map(),
);
export const SYNONYM_MAP = new Map<string, string[]>(allEntries.filter(([title]) => titleCounts.get(title) === 1));

/**
 * Returns all synonym titles for the given input title, excluding the
 * input itself. Returns an empty array if no synonym group is found.
 *
 * Matching is case-insensitive. The returned synonyms preserve the
 * capitalization from the synonym group definition.
 */
export function getSynonyms(title: string): string[] {
    const normalized = title.trim().toLowerCase();
    if (!normalized) return [];

    const group = SYNONYM_MAP.get(normalized);
    if (!group) return [];

    return group.filter((synonym) => synonym.toLowerCase() !== normalized);
}
